import React from 'react';

import { InfinitePagination as InfinitePaginationBase } from '$partials/base/ajax-listing';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const InfinitePagintation = () => {
    return (
        <InfinitePaginationBase>
            <div
                aria-hidden={true}
                className='layout-container layout-site-outer-padding pb-60 flex items-center justify-center'>
                <img
                    className='h-[16x] w-[110px]'
                    src='/images/loading.gif' />
            </div>
        </InfinitePaginationBase>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default InfinitePagintation;
